import React from 'react';
import styled from 'styled-components';

const Marker = ({ children, onClick, active, color }) => {
  return (
    <Root onClick={onClick} style={{borderColor: color}}>
      <Caption active={active}>{children}</Caption>
    </Root>
  );
};

const Root = styled.div`
  width: 24px;
  height: 24px;
  border: 3px solid #fff;
  position: relative;
`;

const Caption = styled.div`
  position: absolute;
  background: rgba(81, 81, 81, 0.54);
  white-space: nowrap;
  padding: 10px 14px;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  border: 1px solid #fff;
  opacity: ${props => props.active ? '1' : '0'};
  font-family: ${({theme}) => theme.font};
  font-size: 12px;
  color: #fff;
  pointer-events: none;
  transition: all 0.5s;
  z-index: 1000;
`;

export default Marker;



// WEBPACK FOOTER //
// ./src/pages/Neighbourhood/elements/Map/elements/Marker.js